module.exports = __webpack_public_path__ + "static/img/logo_login.8ca89750.png";